export default {
  name: '个人中心',
  children: [
    {
      menuId: 1,
      name: '我的订单',
      url: 'myorder',
    },
    {
      menuId: 2,
      name: '我的投稿',
      url: 'contribute',
    },
    {
      menuId: 3,
      name: '基本信息',
      url: 'basicinfo',
    },
    {
      menuId: 4,
      name: '修改密码',
      url: 'updatepwd',
    },
  ],
}
